<template>
  <div>
    <slot name="leaf" :depth="treeDepth" :node="treeItem"></slot>
  </div>
</template>

<script>
import TreeBase from '@/views/newManual/TreeMenuSlot/TreeBase'

export default {
  name: 'TreeLeaf',
  extends: TreeBase,
}
</script>
